import React from 'react';

import ReturnsModule from '../returns/components/ReturnsModule';
import InventoryPermissionGuard from './InventoryPermissionGuard';

export default function InventoryReturnsModule() {
  return (
    <InventoryPermissionGuard
      permissions={[
        { resource: 'inventory.return', action: 'read' },
      ]}
    >
      <ReturnsModule />
    </InventoryPermissionGuard>
  );
}